module.exports = __webpack_public_path__ + "fepro/img/orderdetailsbg@2x.bd0ac9aa.png";